import MuiPaper from '@material-ui/core/Paper';

/**
 * Material UI Paper wrapper.
 *
 * @see
 * [Paper](https://material-ui.com/components/paper/)
 * @see
 * [Paper API](https://material-ui.com/api/paper/)
 *
 * @param {object} props
 */
function Paper(props) {
  return <MuiPaper {...props} />;
}

export default Paper;
